import {
    USER_BOARD_LIST_STORAGE_KEY,
    USER_FAVOURITED_ITEM_STORAGE_KEY,
} from '~/modules/moodboards/config';
import { localStorage } from '~/modules/root/util/browser-storage';

/** Removes locally cached design board data on logout. */
export const removeLocalFavouritedItems = () => {
    localStorage?.removeItem(USER_BOARD_LIST_STORAGE_KEY);
    localStorage?.removeItem(USER_FAVOURITED_ITEM_STORAGE_KEY);
};
